// Runtime multi-tenancy — GOLF ELITE ONLY. On the shared Golf Elite instance
// every club's data lives under /clubs/{clubId}/…; the logged-in club account
// (or a ?c=<clubId> on a public QR link) sets the active clubId. On EVERY other
// build (PBCC and all existing per-DB white-labels) IS_GOLF_ELITE is false, so
// tenantPath is the identity function and all paths stay global exactly as
// before — runtime DB pathing is byte-identical for those builds.
import { IS_GOLF_ELITE } from '../config/siteMode.js'

let _clubId = null

export function setActiveClubId(id) { _clubId = id || null }
export function getActiveClubId() { return _clubId }

// Prefix a database path with the active club's tenant root (Golf Elite only).
export function tenantPath(path) {
  if (IS_GOLF_ELITE && _clubId) return `clubs/${_clubId}/${path}`
  return path
}

// True when tenant scoping is in force (Golf Elite + a resolved clubId).
export function isTenantScoped() {
  return IS_GOLF_ELITE && !!_clubId
}

// Query-string fragment that pins a public (no-login) link to the active club on
// Golf Elite, e.g. `&c=elite-club-abc123`. Empty on every other build, so link
// builders stay byte-identical off-GE. Append to links that already carry `?t=…`.
export function clubParam() {
  return (IS_GOLF_ELITE && _clubId) ? `&c=${encodeURIComponent(_clubId)}` : ''
}
